import React from 'react'
import SurgeryInfoTabs from 'presentation/shared/components/SurgeryInfo/SurgeryInfoTabs'

export default function makePatienSurgeryInfo() {
  return <SurgeryInfoTabs />
}
